import {ValueObject} from '@s-ui/domain'

export class StatsRequestValueObject extends ValueObject {
  /**
   * @param {Object} filters
   * @param {Array} aggregations
   * @param {Object} pagination
   */
}
